import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import TeamWorkflow from '@/data/models/domain/TeamWorkflow'

@RepoSettings<Endpoint>({
  model: TeamWorkflow,
})
@injectable()
@injectFromBase()
export default class TeamWorkflowRepository extends OrmApiRepository<TeamWorkflow> {}
